__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/1ebe59f/";